export const AGE_ICON_TYPE = {
    ROUND: 'round',
    FLAT: 'flat',
    CAPSULE: 'capsule'
}

export const AGE_ANALYTICS_DEFAULT = {
    action: 'Header',
    label: 'Icon_responsible_gaming_click'
}

export const AGE_ICON_TYPE_CSS_SELECTOR = {
    [AGE_ICON_TYPE.ROUND]:{
            '18': 'cgp-themes-icons-age-limit-18-round',
            '21': 'cgp-themes-icons-age-limit-21-round'
        },
    [AGE_ICON_TYPE.FLAT]: {
        '18': 'cgp-themes-icons-age-limit-18-flat',
        '21': 'cgp-themes-icons-age-limit-21-flat'
    },
    [AGE_ICON_TYPE.CAPSULE]: {
        '18': 'cgp-themes-icons-age-limit-18-capsule'
    }
}